import React from "react";
import { GetBrandedUrl, BrandedImage } from "../../Utils/BrandedContentUrls";

/**
 * Component to display the header of the tracking page, including the branded logo.
 */
export const TrackingPageHeader: React.FC = () => {
    return (
        <div className="tracking-page-header">
            <img src={GetBrandedUrl(BrandedImage.Logo)} />
        </div>
    )
}